import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {Checkbox} from '../../checkbox/checkbox';

import {getAdditionalInfo} from './helpers';

import styles from './task-row.module.css';

type Props = {
    isSkipped: boolean | null | undefined;
    isCompleted: boolean;
    canBeCompleted: boolean | null | undefined;
    requirementText: string | null | undefined;
    isAutomated: boolean;
    isAiGenerated?: boolean;
    creatorEntityName?: string | null;
    onChange: (isChecked: boolean) => void;
    checkboxRef: (arg1?: HTMLElement | null | undefined) => void;
    isUpdating: boolean;
};

export function TaskRowIcon(props: Props) {
    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, []);

    return (
        <div className={styles['task-row-icon-container']}>
            <Checkbox
                checked={props.isCompleted}
                disabled={
                    (!props.canBeCompleted && !props.isCompleted) ||
                    props.isUpdating ||
                    props.isSkipped
                }
                isLarge={true}
                isTopAligned={true}
                onChange={props.onChange}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                checkboxRef={props.checkboxRef}
                showX={Boolean(props.isSkipped)}
            />
            {getAdditionalInfo(
                props.isCompleted,
                props.canBeCompleted,
                props.requirementText,
                props.isAutomated,
                props.isSkipped,
                props.isAiGenerated,
                props.creatorEntityName
            )}
        </div>
    );
}
